module.exports = __webpack_public_path__ + "images/emoji/clock8.bf090c8eeb997598419a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock8.png
// module id = +Evk
// module chunks = 14